import { AxiosInstance } from "axios";
import { ShowNotification } from "src/components/common/ShowNotification/ShowNotification";
import ConfigService from '../config/config.service';

export class ApiService {
  private urlApi: string;
  constructor(
    protected restClient: AxiosInstance,
    api: string = "",
    protected shouldValidateAppVersion: boolean = true
  ) { this.urlApi = api === "" ? "" : `${ConfigService.getConfig().baseUrl}${api}`; }

  protected async GET(url: string, responseType = "json") {
    try {
      this.ValidateApplicationVersion();
      const response = (
        await this.restClient.get(this.urlApi + url, { responseType })).data;
      return response;
    }
    catch (error) { return this.handleError(error, ""); }
  }

  protected async FETCH(url: string, setHook: React.Dispatch<React.SetStateAction<any>>, setLoading: React.Dispatch<React.SetStateAction<boolean>>, responseType = "json") {
    try {
      this.ValidateApplicationVersion();
      setLoading(true);
      setHook((await this.restClient.get(this.urlApi + url, { responseType })).data);
    } catch (error) {
      return this.handleError(error, "");
    } finally {
      setLoading(false);
    }
  }

  protected async POST(url: string, body: unknown, responseType = "json") {
    try {
      await this.ValidateApplicationVersion();
      const response = (await this.restClient.post(this.urlApi + url, body, { responseType })).data;
      return response;
    } catch (error) {
      return this.handleError(error, "");
    }
  }

  protected async PUT(url: string, body?: unknown, responseType = "json") {
    try {
      await this.ValidateApplicationVersion();
      const response = (await this.restClient.put(this.urlApi + url, body, { responseType })).data;
      return response;
    } catch (error) {
      return this.handleError(error, "");
    }
  }

  protected async DELETE(url: string, body?: unknown) {
    try {
      await this.ValidateApplicationVersion();
      const response = await this.restClient.delete(this.urlApi + url, body);
      return response;
    } catch (error) {
      return this.handleError(error, "");
    }
  }

  private handleError(error, errorMessage) {
    if (errorMessage) {
      ShowNotification.Error(errorMessage.Message, errorMessage.Description);

      throw error;
    }
    // Comentário mantido onde serão tratadas todos os erros futuramente.
    // ShowNotification.Error("Falha na consulta", "Ocorreu um erro durante a consulta. Tente novamente.");
    throw error;
  }

  private async ValidateApplicationVersion() {
    await this.restClient.get(`${ConfigService.getConfig().apiUrl}/${ConfigService.getConfig().baseUrl}/common-domain/app-version`)
      .then(actualAppVersion => {
        const localStorageVersion = this.getAppVersion();
        if (localStorageVersion?.toString()?.toUpperCase() !== actualAppVersion.data?.toString()?.toUpperCase()) {
          localStorage.clear();
          sessionStorage.clear();
          this.deleteAllCookies();
          localStorage.setItem(ConfigService.getConfig().version, actualAppVersion.data.toString());
          window.location.reload();
        }
      });
  };

  private getAppVersion = () => localStorage.getItem(ConfigService.getConfig().version);

  private deleteAllCookies() {
    const cookies = document.cookie.split(";");
    cookies.forEach(cookie => {
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
    });
  }

}



// WEBPACK FOOTER //
// ./src/services/models/Api.model.ts